module.exports = __webpack_public_path__ + "static/media/frontend.9297d397.svg";